import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {NgbModal, NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {MatSliderModule} from "@angular/material/slider";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {ApiService} from "@ctms/api.service";
import {CreateTherapeuticScheduleModalComponent} from "./modal/create-therapeutic-schedule.modal.component";

type ModuleItem = {
    temp: boolean
    id: number
    title: string
};

type Category = {
    id: number
    title: string
    modules: Array<ModuleItem>
}

@Component({
    selector: 'cdss-create-therapeutic-schedule',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, NgbNavModule, MatSliderModule, DragDropModule],
    providers: [ApiService],
    templateUrl: './create-therapeutic-schedule.component.html',
    standalone: true,
    styleUrl: './create-therapeutic-schedule.component.scss'
})
export class CreateTherapeuticScheduleComponent {
    loading = false;
    visible: boolean = false;

    splitColumnsLimit: number = 5;

    categories: Array<Category> = [
        {id: 1, title: 'Core Modules', modules: [
            {id: 1, title: "Taking the first step", temp: false},
            {id: 2, title: "Support matters", temp: false},
            {id: 3, title: "The Brain and Recovery", temp: false},
            {id: 4, title: "ED Character", temp: false},
            {id: 5, title: "Understanding energy balance", temp: false},
            {id: 6, title: "Readiness Ruler", temp: false},
            {id: 7, title: "Change Cycle", temp: false},
            {id: 8, title: "Looking at both sides", temp: false},
            {id: 9, title: "Building your Self-Care Box", temp: false},
            {id: 10, title: "Understanding your anxiety wave", temp: false},
            {id: 11, title: "Social media", temp: false},
            {id: 12, title: "Healthy flourishing self", temp: false},
            {id: 13, title: "Making your emotions work for you", temp: false},
            {id: 14, title: "What to do when things don't go to plan", temp: false},
        ]},
        {id: 2, title: 'Meal Support', modules: [
            {id: 90, title: "Importance of Meal Support", temp: false},
            {id: 16, title: "Nutrition", temp: false},
            {id: 17, title: "Meal Planning", temp: false},
            {id: 18, title: "Fear Foods Roadmap", temp: false},
        ]},
        {id: 3, title: 'Body', modules: [
            {id: 19, title: "Anorexia and the Body", temp: false},
            {id: 20, title: "What is body image?", temp: false},
            {id: 21, title: "Resisting the 'Appearance Ideal'", temp: false},
            {id: 22, title: "Body image timeline", temp: false},
        ]},
        /*
        {id: 4, title: 'Weight', modules: [
            {id: 23, title: "Weigh-Ins", temp: false},
        ]},
        {id: 5, title: 'Mind', modules: [
            {id: 24, title: "Managing Emotions", temp: false},
            {id: 25, title: "Finding calm in the storm", temp: false},
            {id: 26, title: "Challenging thinking styles", temp: false},
            {id: 27, title: "Building self-esteem", temp: false},
            {id: 28, title: "Self-compassion", temp: false},
            {id: 29, title: "Identity", temp: false},
        ]},
         */
    ]

    items: Array<ModuleItem> = [
        {id: 1, title: "Taking the first step", temp: false},
        {id: 2, title: "Support matters", temp: false},
        {id: 3, title: "The Brain and Recovery", temp: false},
        {id: 4, title: "ED Character", temp: false},
        {id: 5, title: "Understanding energy balance", temp: false},
        {id: 6, title: "Readiness Ruler", temp: false},
        {id: 7, title: "Change Cycle", temp: false},
        {id: 8, title: "Looking at both sides", temp: false},
        {id: 9, title: "Building your Self-Care Box", temp: false},
        {id: 10, title: "Understanding your anxiety wave", temp: false},
        {id: 11, title: "Social media", temp: false},
        {id: 12, title: "Healthy flourishing self", temp: false},
        {id: 13, title: "Making your emotions work for you", temp: false},
        {id: 14, title: "What to do when things don't go to plan", temp: false},
    ]

    draggingItems: Array<ModuleItem> = []
    selectedItems: Array<ModuleItem> = []

    earlyStageItems: Array<ModuleItem> = [
        {id: 1, title: "Taking the First Step", temp: false},
        {id: 1, title: "Support Matters", temp: false},
        {id: 1, title: "The Importance of Weighing", temp: false},
        {id: 1, title: "Anorexia and the Brain", temp: false},
        {id: 1, title: "Anorexia and the Body", temp: false},
        {id: 15, title: "The Importance of Meal Support", temp: false},
        {id: 1, title: "Finding your flow", temp: false},
        {id: 1, title: "Externalisation", temp: false},
        {id: 1, title: "Readiness Ruler", temp: false},
        {id: 1, title: "The Phases of Change", temp: false},
        {id: 1, title: "Looking at both sides", temp: false},
    ]
    midStageItems: Array<ModuleItem> = [
        {id: 1, title: "Managing Emotions", temp: false},
        {id: 1, title: "Finding calm in the storm", temp: false},
        {id: 1, title: "Building your Self-Care Box", temp: false},
        {id: 1, title: "Understanding your anxiety wave", temp: false},
        {id: 1, title: "Challenging thinking styles", temp: false},
        {id: 1, title: "Introduction to identity", temp: false},
        {id: 1, title: "Fear Foods Roadmap", temp: false},
        {id: 1, title: "Mealtime practice", temp: false},
        {id: 1, title: "What is body image?", temp: false},
        {id: 1, title: "Resisting the ‘Appearance Ideal’", temp: false},
        {id: 1, title: "Body image timeline", temp: false},
        {id: 1, title: "Social Media: Friend or foe?", temp: false},
        {id: 1, title: "Building self-esteem", temp: false},
    ]
    lateStageItems: Array<ModuleItem> = [
        {id: 1, title: "Self-compassion", temp: false},
        {id: 1, title: "Recovery and Identity", temp: false},
        {id: 1, title: "Making your emotions work for you", temp: false},
        {id: 1, title: "What to do when things don't go to plan", temp: false},
        {id: 1, title: "Taking smart risks", temp: false},
        {id: 1, title: "Keeping your recovery on track ", temp: false},
        {id: 1, title: "Why Sleep Matters in Eating Disorders", temp: false},
        {id: 1, title: "Discovering your role models", temp: false},
        {id: 1, title: "Reflecting on your journey", temp: false},
        {id: 1, title: "Endings", temp: false},
    ]

    draggingOutsideSourceList: boolean = false;

    constructor(
        public toastr: ToastrService,
        private modal: NgbModal,
    ) {
    }

    ngOnInit(): void {
    }

    isOut(item: ModuleItem): boolean {
        let selected = false
        this.earlyStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                selected = true
            }
        })
        this.midStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                selected = true
            }
        })
        this.lateStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                selected = true
            }
        })
        this.draggingItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                selected = true
            }
        })
        if (item.id == 14) {
            console.log("isOut", selected)
        }
        return selected
    }

    select(event, item: ModuleItem) {
        console.log(event);
        if (!event.ctrlKey && !event.metaKey) {
            this.selectedItems = []
        }
        this.selectedItems.push(item)
    }

    isSelected(item: ModuleItem): boolean {
        let selected = false
        this.selectedItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                selected = true
            }
        })
        return selected
    }

    dropped(event) {
        if (event.container.id == event.previousContainer.id) {
            return
        }
        if (event.container.id == 'early-stage-list') {
            this.earlyStageItems.push(event.item.data)
        }
        if (event.container.id == 'mid-stage-list') {
            this.midStageItems.push(event.item.data)
        }
        if (event.container.id == 'late-stage-list') {
            this.lateStageItems.push(event.item.data)
        }
    }

    dragStarted(event) {
        this.draggingOutsideSourceList = false;
        console.log("dragStarted", event);
    }

    dragEnded(event) {
        this.items = this.items.filter((f) => !f.temp);
    }

    enteredCategory(event) {
        this.items = this.items.filter((f) => !f.temp);
        this.draggingOutsideSourceList = false
    }

    exitedCategory(event) {
        const currentIdx = event.container.data.findIndex(
            (f) => f.id === event.item.data.id
        );
        this.items.splice(currentIdx + 1, 0, {
            ...event.item.data,
            temp: true,
        });
    }

    isDisabled(item: ModuleItem): boolean {
        if (item.temp) {
            return true
        }
        let disabled = false
        this.earlyStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                disabled = true
            }
        })
        this.midStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                disabled = true
            }
        })
        this.lateStageItems.forEach(currentItem => {
            if (currentItem.id === item.id) {
                disabled = true
            }
        })
        return disabled
    }

    enteredStage(event) {
        this.draggingOutsideSourceList = true
    }

    exitedStage(event) {
        console.log('exitedStage', event);
    }

    showModal(type: number) {
        const ref = this.modal.open(CreateTherapeuticScheduleModalComponent, { size: 'md', centered: true })

        switch (type) {
            case 15:
            case 90:
                ref.componentInstance.type = 2
                break;
            default:
                ref.componentInstance.type = 1
        }
    }
}
